module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/2_deeb3cbecce7d3e2bce9939e930cbaec.png";